import React, { useState, useEffect, useCallback } from 'react'
import { GoogleMap, useJsApiLoader, Marker, Circle, InfoWindow } from '@react-google-maps/api'
import MarkerImage from './MarkerImage.jsx'
import { CCard, CCardBody } from '@coreui/react'
import './FacilityMap.css'

const containerStyle = {
  width: '100%',
   height: '70vh',
}

const center = {
  lat: 27.964157,
  lng: -82.4572,
}

const SchedulerFacilityMap = ({ selectedProviderDataRed, facilities, selectedProviderFacilities, providerList, Radius, types, MarkerClick = () => {}, onFilter = () => {}, setFacilities, isDropdownVisible, scheduleAppointmentPatinet, scheduledPatient }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyBQWNt0CI8rCrIdFt6_AUgExvRONdbm_ZI',
    // libraries: 'geometry'
  })
  const [selectedProvider, setSelectedProvider] = useState('')
  const [selectedProviderFacitily, setSelectedProviderFacitily] = useState([])
  const [hoveredFacility, setHoveredFacility] = useState(null) // State to manage hovered facility
  const [map, setMap] = useState(null)
  const [zoom, setZoom] = useState(1)
  const [selectedFacilityTypeFilter, setSelectedFacilityTypeFilter] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState(null)
 
  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center)
    map.setZoom(10)
    setMap(map)
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])

  const filteredProviderList = selectedProvider ? providerList.filter((provider) => provider.Name === selectedProvider) : providerList

  // const StatusMap = {
  //   "In Progress": "#ffc107",
  //   "Completed": "red",
  //   "Pending": "green",
  //   "Sister": ""
  // };
  // const StatusMap = {
  //   'Not Credentialed': 'orange',
  //   In: 'green',
  //   'In Progress': '#ffe907',
  //   'Not In': 'red',
  //   Sister: '',
  // }

  const StatusMap = {
    'Not In': 'red',
    'Credentialing (In Progress)': 'yellow',
    Credentialed: 'green',
  }


  const testMarker = (facility, isPresent) => {
    let credentialed = selectedProviderFacilities.filter((item) => parseInt(item.FacilityID) == facility.ID)[0]
    let strokeColor
    if (providerList.length > 0) {
      strokeColor = isPresent ? (credentialed?.Credentialed == 'Yes' ? 'green' : 'yellow') : 'red'
      //  strokeColor =  credentialed?.Credentialed == 'Yes' ? 'green' :  'red';
    } else {
      strokeColor = 'green'
    }

    return `data:image/svg+xml;charset=UTF-8;base64,${btoa(
      `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" stroke-linejoin="square">
        <rect x="2" y="2" width="28" height="28" rx="6" ry="6" />
        <text x="16" y="21" text-anchor="middle" font-size="16" font-weight="200" fill="#000000">${facility.Marker}</text>
      </svg>`,
    )}`
  }

  const StatusColour = () => (
    <div className="legend-section status-legend">
      <div className="legend-title">Status Legend</div>
      <div className="legend-items">
        {Object.keys(StatusMap).map((status) => {
          const isSelected = selectedStatus === status

          return (
            <button
              key={status}
              type="button"
              className={`legend-item ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  setSelectedStatus(null)
                  onFilter('status', 'all')
                } else {
                  setSelectedStatus(status)
                  onFilter('status', status, '', '', true)
                }
              }}
            >
              <span className="legend-color" style={{ backgroundColor: StatusMap[status], borderColor: StatusMap[status] }} />
              <span className="legend-text">{status}</span>
            </button>
          )
        })}
      </div>
    </div>
  )

  const MapLegend = () => (
    <div className="legend-section map-legend">
      <div className="legend-title">Map Legend</div>
      <div className="legend-items">
        {types?.map((obj) => {
          const isSelected = selectedFacilityTypeFilter === obj.Name

          return (
            <button
              key={obj.Name}
              type="button"
              className={`legend-item ${isSelected ? 'selected' : ''}`}
              onClick={() => {
                if (isSelected) {
                  setSelectedFacilityTypeFilter(null)
                  onFilter('type', 'all')
                } else {
                  setSelectedFacilityTypeFilter(obj.Name)

                  if (providerList.length > 0) {
                    onFilter('type', 'radius', providerList[0].ID, obj.Name)
                  } else {
                    onFilter('type', obj.Name)
                  }
                }
              }}
            >
              <div className={`map-box ${isSelected ? 'selected' : ''}`}>{obj.Marker}</div>
              <span className="legend-text">{obj.Name}</span>
            </button>
          )
        })}
      </div>
    </div>
  )

  function haversineDistance(lat1, lng1, lat2, lng2) {
    const toRadians = (degree) => degree * (Math.PI / 180)

    const R = 6371e3 // Earth's radius in meters
    const φ1 = toRadians(lat1)
    const φ2 = toRadians(lat2)
    const Δφ = toRadians(lat2 - lat1)
    const Δλ = toRadians(lng2 - lng1)

    const a = Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distanceInMeters = R * c
    const distanceInMiles = distanceInMeters / 1609.344

    return distanceInMiles
  }

  const getDistanceInMiles = (lat1, lng1, lat2, lng2) => {
    const distanceInMiles = haversineDistance(lat1, lng1, lat2, lng2)
    return distanceInMiles.toFixed(2) // return distance in miles
  }



  const selectedProviderData = scheduleAppointmentPatinet?.[0]

  const renderFacilities = (props) => {
    return facilities.map((facility, index) => {
      const isFacilityInSelectedProvider = selectedProviderFacilities.some((selectedFacility) => parseInt(selectedFacility.FacilityID) == facility.ID)

      let distance = null
      if (selectedProviderData) {
        distance = getDistanceInMiles(parseFloat(selectedProviderData.Lat), parseFloat(selectedProviderData.Lng), parseFloat(facility.Lat), parseFloat(facility.Lng))
      }
      return (
        <React.Fragment key={index}>
          <Marker
            position={{ lat: parseFloat(facility.Lat), lng: parseFloat(facility.Lng) }}
            icon={{
              url: testMarker(facility, isFacilityInSelectedProvider),
              scaledSize: new window.google.maps.Size(24, 24),
            }}
            onMouseOver={() => setHoveredFacility(facility)}
            onMouseOut={() => setHoveredFacility(null)}
            onClick={() => MarkerClick(facility.Name)}
          />
          {hoveredFacility && hoveredFacility.Name === facility.Name && (
            <InfoWindow position={{ lat: parseFloat(facility.Lat), lng: parseFloat(facility.Lng) }}
            options={{
                pixelOffset: new window.google.maps.Size(0, -10),
              }}>
              <div style={{ lineHeight: '1.4' }}>
                <p className="mb-1">
                  <strong>Name:</strong> {facility.Name}
                </p>
                <p className="mb-1">
                  <strong>Address:</strong> {facility.Address}
                </p>
                <p className="mb-1">
                  <strong>Type:</strong> {facility.Type}
                </p>
                <p className="mb-1">
                  <strong>Distance From Provider:</strong> {distance} miles
                </p>
              </div>
            </InfoWindow>
          )}
        </React.Fragment>
      )
    })
  }

  // useEffect(() => {

  //   let data = providerList.map((provider, index) => {
  //     onFilter("type", 'radius', provider.ID)
  //   })

  // }, [Radius])

  const renderProviders = (props) => {
    if (scheduleAppointmentPatinet && scheduleAppointmentPatinet.length > 0) {
      return scheduleAppointmentPatinet.map((provider, index) => {
        return (
          <React.Fragment key={index}>
            <Circle
              onClick={() => onFilter('type', 'radius', provider.ID)}
              radius={Math.round(Radius * 1609.34)}
              center={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}
            />
            <Marker
              position={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}
              icon={{
                url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(
                  `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red}" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`,
                )}`,
              }}
              onMouseOver={() => setHoveredFacility(provider)}
              onMouseOut={() => setHoveredFacility(null)}
              onClick={() => MarkerClick(provider.Name)}
            />
            {hoveredFacility && hoveredFacility.Name === provider.Name && (
              <InfoWindow position={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}>
                <div>
                  <b>Name:</b> {provider.Name}
                  <p>
                    <b>Address:</b> {provider.Address}
                  </p>
                </div>
              </InfoWindow>
            )}
          </React.Fragment>
        )
      })
    } else {
      return providerList.map((provider, index) => {
        return (
          <React.Fragment key={index}>
            <Circle onClick={() => onFilter('type', 'radius', provider.ID)} radius={Math.round(Radius * 1609.34)} center={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }} />
            <Marker
              position={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}
              icon={{
                url: `data:image/svg+xml;charset=UTF-8;base64,${btoa(
                  `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="red}" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`,
                )}`,
              }}
              onMouseOver={() => setHoveredFacility(provider)}
              onMouseOut={() => setHoveredFacility(null)}
              onClick={() => MarkerClick(provider.Name)}
            />
            {hoveredFacility && hoveredFacility.Name === provider.Name && (
              <InfoWindow position={{ lat: parseFloat(provider.Lat), lng: parseFloat(provider.Lng) }}>
                <div>
                  <b>Name:</b> {provider.Name}
                  <p>
                    <b>Address:</b> {provider.Address}
                  </p>
                </div>
              </InfoWindow>
            )}
            ;
          </React.Fragment>
        )
      })
    }
  }

  return isLoaded ? (
    <div className="facility-map-theme">
      <div style={{ position: 'relative' }}>
        <GoogleMap mapContainerStyle={containerStyle} center={center} onLoad={onLoad} onUnmount={onUnmount}>
          {renderFacilities()}
          {renderProviders()}
        </GoogleMap>
        <div className="legend-wrapper">
          <StatusColour />
          <MapLegend />
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default SchedulerFacilityMap
